import React from 'react';
import TableWithSummary from '../../../../components/table/TableWithSummary';
import { ACCOUNT_USER_DETAIL_CS_INQUIRY_HISTORY_LIST_FILTER_OPTION_MODEL } from '../../../../store/modules/account/user/models';
import { CS_INQUIRY_LIST_SORT_OPTION_MODEL } from '../../../../store/modules/cs/inquiry/models';
import { LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import { CS_INQUIRY_LIST_TABLE_EMPTY_TEXT } from '../../../../constants/service/app/csInquiryConstants';
import columns from '../../../account/user/detail/AccountUserDetailCsInquiryInfo/columns';

const OrderInquiryInfo = (props) => {
  const { inquiryInfo, getList, getExcelDownload } = props;

  if (!inquiryInfo.list.length) return null;

  const { list, filterOption, sortOption, pagination, summary } = inquiryInfo;
  return (
    <div className="order-detail-content inquiry-info-content">
      <div className="title">1:1 문의 리스트</div>

      <TableWithSummary
        className="order-detail-inquiry-list-table"
        data={list}
        totalCnt={summary.totalCnt}
        initialOption={{
          filterOption: ACCOUNT_USER_DETAIL_CS_INQUIRY_HISTORY_LIST_FILTER_OPTION_MODEL,
          sortOption: CS_INQUIRY_LIST_SORT_OPTION_MODEL,
          pagination: LIST_PAGINATION_MODEL,
        }}
        isStriped={true}
        emptyText={CS_INQUIRY_LIST_TABLE_EMPTY_TEXT}
        showPagination
        filterOption={filterOption}
        sortOption={sortOption}
        pagination={pagination}
        getList={getList}
        getExcelDownload={getExcelDownload}
        columns={(utils) => columns(utils)}
      />
    </div>
  );
};

export default OrderInquiryInfo;
